/* ============================================================
   SMARTCUBES — Duo-bygger v7.2
   Hver størrelse er et kort med farveprikker og −/+. Kunden lægger
   bakker i sin Duo (maks. 2) — to ens, to størrelser eller to farver.
   "Din Duo"-baren nederst viser pladser, fremdrift, besparelse og køb.
   Den vises, når sidens købsknap er ude af syne — men ikke over
   kortene, før kunden har valgt den første bakke.
   Valget slås op i Duo-produktets varianter ("500 ml Pink / 350 ml Blå"),
   uanset rækkefølge. Indlæses efter smartcubes-pdp.js og overtager
   købsknappen på siden.
   ============================================================ */
(function () {
  'use strict';

  var MAX = 2;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function fmt(p) {
    return (p / 100).toLocaleString('da-DK', { minimumFractionDigits: 2 }) + ' kr';
  }

  function fmtShort(p) {
    var kr = p / 100;
    return (kr % 1 === 0
      ? kr.toLocaleString('da-DK')
      : kr.toLocaleString('da-DK', { minimumFractionDigits: 2 })) + ' kr';
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function pulse(el, cls) {
    if (!el) return;
    cls = cls || 'is-pulse';
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  function init(root) {
    var box = root.querySelector('[data-scd]');
    if (!box || box.getAttribute('data-scd-init') === '1') return;
    box.setAttribute('data-scd-init', '1');

    var variants, imgs;
    try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }
    try { imgs = JSON.parse(box.getAttribute('data-scd-imgs') || '{}'); } catch (e) { imgs = {}; }

    var map = {};
    variants.forEach(function (v) {
      map[v.opts[0] + '|' + v.opts[1]] = v;
      map[v.opts[1] + '|' + v.opts[0]] = v;
    });

    var preorder = root.getAttribute('data-preorder') === '1';
    var addLabel = preorder ? (root.getAttribute('data-po-label') || 'Forudbestil') : 'Læg i kurv';
    var title = (root.getAttribute('data-duo-title') || 'Duo').split(' (')[0];

    var idInput = root.querySelector('[data-scp-variant-id]');
    var addBtn = root.querySelector('[data-scp-add]');
    var addText = root.querySelector('[data-scp-add-text]');
    var addPrice = root.querySelector('[data-scp-add-price]');
    var priceEl = root.querySelector('[data-scp-price]');
    var sName = root.querySelector('[data-scp-s-name]');
    var sPrice = root.querySelector('[data-scp-s-price]');
    var sBtn = root.querySelector('[data-scp-s-btn]');
    var sThumb = root.querySelector('[data-scp-s-thumb]');

    var cards = box.querySelectorAll('[data-scd-card]');
    var note = box.querySelector('[data-scd-note]');
    var upsell = box.querySelector('[data-scd-upsell]');

    var bar = root.querySelector('[data-scd-bar]');
    var barCount = bar && bar.querySelector('[data-scd-bar-count]');
    var barSlots = bar && bar.querySelector('[data-scd-bar-slots]');
    var barTrack = bar && bar.querySelector('[data-scd-bar-track]');
    var barFill = bar && bar.querySelector('[data-scd-bar-fill]');
    var barCta = bar && bar.querySelector('[data-scd-bar-cta]');
    var barText = bar && bar.querySelector('[data-scd-bar-text]');
    var barPrice = bar && bar.querySelector('[data-scd-bar-price]');

    /* Opsummering lige over købsknappen, så valget kan ses ved prisen */
    var summary = root.querySelector('[data-scd-summary]');
    if (!summary && addBtn && addBtn.parentNode) {
      summary = document.createElement('p');
      summary.className = 'scd-summary';
      summary.setAttribute('data-scd-summary', '');
      addBtn.parentNode.insertBefore(summary, addBtn);
    }

    var labels = {}, names = {}, cardBySize = {};
    each(cards, function (c) {
      var size = c.getAttribute('data-scd-card');
      labels[size] = c.getAttribute('data-label') || size;
      names[size] = c.getAttribute('data-name') || size;
      cardBySize[size] = c;
    });

    var colours = [];
    if (cards.length) {
      each(cards[0].querySelectorAll('[data-scd-dot]'), function (d) { colours.push(d.getAttribute('data-scd-dot')); });
    }

    function keyOf(s) { return s.size + ' ' + s.colour; }
    function find(a, b) { return map[a + '|' + b] || null; }

    function anyWith(key) {
      for (var k in map) {
        if (map[k].available && k.split('|')[0] === key) return true;
      }
      return false;
    }
    function okWith(key, other) {
      if (!other) return anyWith(key);
      var v = find(key, other);
      return !!(v && v.available);
    }

    /* Bakkerne i Duo'en, i den rækkefølge kunden har valgt dem */
    var picks = [];
    var cardColour = {};
    var overflow = false;

    function canAdd(key) {
      if (picks.length >= MAX) return false;
      return okWith(key, picks.length ? keyOf(picks[0]) : null);
    }
    function canSet(i, key) {
      return okWith(key, picks.length === MAX ? keyOf(picks[1 - i]) : null);
    }
    function lastIdx(size, colour) {
      var i;
      if (colour) {
        for (i = picks.length - 1; i >= 0; i--) if (picks[i].size === size && picks[i].colour === colour) return i;
      }
      for (i = picks.length - 1; i >= 0; i--) if (picks[i].size === size) return i;
      return -1;
    }
    function shortName(s) { return (names[s.size] || s.size) + ' · ' + s.colour; }

    /* Hvert kort starter på den første farve, der kan købes */
    each(cards, function (c) {
      var size = c.getAttribute('data-scd-card');
      var pick = colours[0];
      for (var i = 0; i < colours.length; i++) {
        if (anyWith(size + ' ' + colours[i])) { pick = colours[i]; break; }
      }
      cardColour[size] = pick;
    });

    var addSeen = true, gridSeen = true;
    function setH() {
      if (bar) document.documentElement.style.setProperty('--scd-bar-h', bar.offsetHeight + 'px');
    }
    function syncBar() {
      if (!bar) return;
      var on = !addSeen && (picks.length > 0 || !gridSeen);
      if (bar.classList.contains('is-on') === on) return;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('scd-bar-on', on);
      if (on) setH();
    }
    function reveal(el) {
      if (!el || el.hidden) return;
      var r = el.getBoundingClientRect();
      var limit = window.innerHeight - (bar && bar.classList.contains('is-on') ? bar.offsetHeight : 0) - 12;
      if (r.bottom > limit) window.scrollBy({ top: r.bottom - limit, behavior: 'smooth' });
    }

    function say(msg) {
      if (!note) return;
      note.textContent = msg || '';
      note.hidden = !msg;
    }

    function render() {
      var full = picks.length === MAX;
      box.classList.toggle('is-full', full);

      each(cards, function (card) {
        var size = card.getAttribute('data-scd-card');
        var col = cardColour[size];
        var qty = 0;
        picks.forEach(function (p) { if (p.size === size) qty++; });
        var li = lastIdx(size);

        card.classList.toggle('is-picked', qty > 0);

        var q = card.querySelector('[data-scd-qty]');
        if (q) q.textContent = qty;

        var badge = card.querySelector('[data-scd-card-badge]');
        if (badge) {
          badge.hidden = qty === 0;
          badge.textContent = qty === 2 ? '2 i din ' + title : 'I din ' + title;
        }

        var img = card.querySelector('[data-scd-card-img]');
        var k = size + ' ' + col;
        if (img && imgs[k] && img.getAttribute('src') !== imgs[k]) img.src = imgs[k];
        if (img) img.alt = (names[size] || size) + ' i ' + col;

        each(card.querySelectorAll('[data-scd-dot]'), function (d) {
          var c = d.getAttribute('data-scd-dot');
          var on = c === col;
          var key = size + ' ' + c;
          var ok = li >= 0 ? canSet(li, key) : (full ? anyWith(key) : canAdd(key));
          d.classList.toggle('is-active', on);
          d.classList.toggle('is-soldout', !ok);
          d.setAttribute('aria-pressed', on ? 'true' : 'false');
          d.setAttribute('aria-label', c + (ok ? '' : ' – udsolgt'));
        });

        var plusOk = false;
        if (!full) {
          for (var i = 0; i < colours.length; i++) {
            if (canAdd(size + ' ' + colours[i])) { plusOk = true; break; }
          }
        }
        var minus = card.querySelector('[data-scd-minus]');
        var plus = card.querySelector('[data-scd-plus]');
        if (minus) minus.disabled = qty === 0;
        if (plus) {
          plus.classList.toggle('is-dim', !plusOk);
          plus.setAttribute('aria-disabled', plusOk ? 'false' : 'true');
        }
        card.classList.toggle('is-soldout', !full && !plusOk && qty === 0);
      });

      var v = full ? find(keyOf(picks[0]), keyOf(picks[1])) : null;
      var ok = !!(v && v.available);

      if (idInput) {
        if (ok) { idInput.value = v.id; idInput.disabled = false; }
        else idInput.disabled = true;
      }

      if (full && !ok) say('Den kombination er udsolgt lige nu. Vælg en anden farve eller størrelse.');

      var btnLabel;
      if (picks.length === 0) btnLabel = 'Vælg 2 bakker';
      else if (!full) btnLabel = 'Vælg 1 bakke mere';
      else btnLabel = ok ? addLabel : 'Udsolgt';

      if (addBtn) addBtn.disabled = !ok;
      if (addText) addText.textContent = btnLabel;
      if (addPrice) addPrice.textContent = ok ? fmt(v.price) : '';
      if (priceEl && ok) priceEl.textContent = fmt(v.price);
      if (sBtn) { sBtn.disabled = !ok; sBtn.textContent = btnLabel; }

      function slotText(i) {
        var s = picks[i];
        return s ? esc(shortName(s)) : 'bakke ' + (i + 1) + ' mangler';
      }
      if (summary) {
        summary.innerHTML = '<span>Din ' + esc(title) + '</span>' + slotText(0) + ' <i>+</i> ' + slotText(1);
        summary.classList.toggle('is-waiting', !full);
      }
      if (sName) sName.textContent = full ? title + ' · ' + shortName(picks[0]) + ' + ' + shortName(picks[1]) : title;
      if (sPrice && ok) sPrice.textContent = fmt(v.price);
      if (sThumb && picks[0] && imgs[keyOf(picks[0])]) sThumb.src = imgs[keyOf(picks[0])];

      if (upsell) upsell.hidden = !(overflow && full);

      if (bar) {
        bar.classList.toggle('is-full', full && ok);
        if (barCount) {
          barCount.textContent = full && ok
            ? 'Klar – ' + MAX + ' af ' + MAX + ' bakker valgt'
            : picks.length + ' af ' + MAX + ' bakker valgt';
        }
        if (barFill) barFill.style.width = (picks.length / MAX * 100) + '%';
        if (barTrack) barTrack.setAttribute('aria-valuenow', picks.length);
        if (barCta) {
          barCta.disabled = full && !ok;
          barCta.classList.toggle('is-pending', !ok);
        }
        if (barText) barText.textContent = full && ok ? (preorder ? addLabel + ' ' + title : 'Læg ' + title + ' i kurv') : btnLabel;
        if (barPrice && ok) barPrice.textContent = fmtShort(v.price);
        if (barSlots) {
          var html = '';
          for (var i = 0; i < MAX; i++) {
            var s = picks[i];
            if (s) {
              var src = imgs[keyOf(s)];
              html += '<button type="button" class="scd-slot is-filled" data-scd-slot="' + i + '" aria-label="Fjern ' + esc(shortName(s)) + '">' +
                (src ? '<img src="' + esc(src) + '" alt="" width="46" height="46">' : esc(names[s.size] || s.size)) +
                '<span class="scd-slot__x" aria-hidden="true">×</span></button>';
            } else {
              html += '<span class="scd-slot" aria-hidden="true">' + (i + 1) + '</span>';
            }
          }
          barSlots.innerHTML = html;
        }
        syncBar();
      }
    }

    function add(size) {
      if (picks.length >= MAX) {
        overflow = true;
        say('');
        render();
        pulse(bar, 'is-nudge');
        reveal(upsell);
        return;
      }
      var c = cardColour[size];
      if (!canAdd(size + ' ' + c)) {
        var alt = null;
        colours.forEach(function (cc) { if (!alt && canAdd(size + ' ' + cc)) alt = cc; });
        if (!alt) {
          say((names[size] || size) + ' kan ikke kombineres med dit første valg lige nu. Vælg en anden størrelse.');
          render();
          return;
        }
        say((names[size] || size) + ' i ' + c + ' er udsolgt i den kombination – vi har valgt ' + alt + '.');
        c = alt;
        cardColour[size] = alt;
      } else {
        say('');
      }
      picks.push({ size: size, colour: c });
      render();
      pulse(cardBySize[size]);
    }

    function removeAt(i) {
      if (i < 0 || i >= picks.length) return;
      picks.splice(i, 1);
      overflow = false;
      say('');
      render();
    }

    function setColour(size, c) {
      var i = lastIdx(size);
      if (i >= 0) {
        if (!canSet(i, size + ' ' + c)) {
          say((names[size] || size) + ' i ' + c + ' er udsolgt i den kombination.');
          render();
          return;
        }
        picks[i].colour = c;
      }
      cardColour[size] = c;
      say('');
      render();
      if (i >= 0) pulse(cardBySize[size]);
    }

    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-scd-plus],[data-scd-minus],[data-scd-dot]');
      if (!t || !box.contains(t)) return;
      var card = t.closest('[data-scd-card]');
      if (!card) return;
      var size = card.getAttribute('data-scd-card');
      if (t.hasAttribute('data-scd-plus')) add(size);
      else if (t.hasAttribute('data-scd-minus')) removeAt(lastIdx(size, cardColour[size]));
      else setColour(size, t.getAttribute('data-scd-dot'));
    });

    if (barSlots) {
      barSlots.addEventListener('click', function (e) {
        var t = e.target.closest('[data-scd-slot]');
        if (t) removeAt(parseInt(t.getAttribute('data-scd-slot'), 10));
      });
    }

    if (barCta) {
      barCta.addEventListener('click', function () {
        if (addBtn && !addBtn.disabled) { addBtn.click(); return; }
        var grid = box.querySelector('.scd-grid') || box;
        var y = grid.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    }

    /* Baren vises, når sidens egen købsknap er ude af syne — men ikke
       oven på kortene, før kunden har valgt den første bakke */
    if (bar) {
      var gridEl = box.querySelector('.scd-grid');
      if (addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          addSeen = entries[0].isIntersecting;
          syncBar();
        }).observe(addBtn);
        if (gridEl) {
          new IntersectionObserver(function (entries) {
            gridSeen = entries[0].isIntersecting;
            syncBar();
          }, { threshold: 0.2 }).observe(gridEl);
        }
      } else {
        addSeen = false;
        gridSeen = false;
      }
      window.addEventListener('resize', function () { if (bar.classList.contains('is-on')) setH(); });
    }

    render();
    /* smartcubes-pdp.js sætter knappen ved indlæsning — sørg for at vores valg vinder */
    setTimeout(render, 0);
    window.addEventListener('load', render);
  }

  function boot() {
    each(document.querySelectorAll('[data-scp][data-duo-builder="1"]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();